// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarregIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarregIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarregIconOutlined = function DrrpDarregIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarregIconOutlinedSvg
  }));
};

DrrpDarregIconOutlined.displayName = 'DrrpDarregIconOutlined';
export default React.forwardRef(DrrpDarregIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarregIconOutlined.js
// module id = 2521
// module chunks = 0